import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

export type AuthState = {
  token: string | null;
  expiresAt: Date | null;
};

const initialState: AuthState = {
  token: null,
  expiresAt: null,
};

export type TokenReceived = {
  token: string;
  expiresAt: string;
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    tokenReceived(state, action: PayloadAction<TokenReceived>) {
      state.token = action.payload.token;
      state.expiresAt = new Date(action.payload.expiresAt);
    },
    loggedOut(state) {
      state.token = null;
      state.expiresAt = null;
    },
  },
});
